import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { SizeMe } from "react-sizeme";
import { Button, Paper, Box } from "@material-ui/core";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import styles from "@styles/styles";
import theme from "@styles/theme";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function PdfViewer(props: { file: string }) {
  const [numPages, setNumPages] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState<number>(1);

  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setNumPages(numPages);
  }

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <SizeMe monitorHeight={true} monitorWidth={true}>
        {({ size }) => {
          // determine whether width or height is limiting factor to display the page
          // TODO at this point only A4 is correctly supported
          // TODO get the width and height of the document from the api call and then determine
          // TODO the ratio
          const divHeight = size.height ?? 0;
          const divWidth = size.width ?? 0;
          const documentWidth = divHeight * (210 / 297);
          const setHeight = divWidth > documentWidth;
          return (
            <div
              style={{
                height: "100%",
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Document file={props.file} onLoadSuccess={onDocumentLoadSuccess}>
                <Paper
                  style={{
                    boxShadow: theme.shadows[5],
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: setHeight ? divHeight - 20 : undefined,
                    width: !setHeight ? divWidth - 20 : undefined,
                  }}
                >
                  <Page
                    key={`page_${pageNumber}`}
                    pageNumber={pageNumber}
                    renderAnnotationLayer={false}
                    renderTextLayer={false}
                    // the -20 is a padding around the div
                    height={setHeight ? divHeight - 40 : undefined}
                    width={!setHeight ? divWidth - 40 : undefined}
                  />
                </Paper>
              </Document>
              <div style={{ position: "absolute", bottom: 30 }}>
                <Paper
                  elevation={3}
                  style={{ display: "flex", alignItems: "center", height: 40, borderRadius: 10 }}
                >
                  <Button
                    disabled={pageNumber <= 1}
                    style={{ height: "100%", width: 5 }}
                    onClick={() => {
                      setPageNumber(pageNumber - 1);
                    }}
                  >
                    <ChevronLeftIcon fontSize={"small"} />
                  </Button>
                  <Box px={1}>
                    {" "}
                    {pageNumber} of {numPages}{" "}
                  </Box>
                  <Button
                    disabled={pageNumber >= numPages}
                    style={{ height: "100%" }}
                    onClick={() => {
                      setPageNumber(pageNumber + 1);
                    }}
                  >
                    <ChevronRightIcon fontSize={"small"} />
                  </Button>
                </Paper>
              </div>
            </div>
          );
        }}
      </SizeMe>
    </div>
  );
}
